import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=57da9a64&lang=scss&scoped=true"

import exportComponent from "D:\\工作区\\exoticplay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57da9a64"]])

export default __exports__